import React from "react";

// One schedule row: Gantt-like bar (offset/width as % of the project span), critical flag, float, % complete, slip.
export default function ActivityRow({ a, onProgress }) {
  return (
    <li className="border border-erf-borderCream rounded bg-white p-3 space-y-2" data-testid={`pm-act-${a.id}`}>
      <div className="flex flex-wrap items-baseline gap-2">
        <span className="font-semibold break-words min-w-0">{a.name}</span>
        {a.critical && <span className="text-xs font-nav uppercase bg-red-50 text-red-800 border border-red-200 rounded px-2" data-testid={`pm-crit-${a.id}`}>Critical</span>}
        <span className="text-xs text-erf-dark/70 ml-auto">{a.early_start}{a.kind === "milestone" ? " (milestone)" : ` → ${a.early_finish}`}</span>
      </div>
      <div className="relative h-3 rounded bg-erf-creamSecondary" aria-hidden="true">
        <div className={`absolute top-0 h-3 rounded ${a.critical ? "bg-red-700" : "bg-erf-dark"}`}
          style={{ left: `${a.bar.offset_pct}%`, width: `${Math.max(a.bar.width_pct, 1)}%` }} />
      </div>
      <div className="flex flex-wrap items-center gap-3 text-xs">
        <span data-testid={`pm-float-${a.id}`}>Float {a.total_float} d</span>
        <span>{a.percent_complete}% done</span>
        {a.finish_slip_days != null && <span data-testid={`pm-slip-${a.id}`}>{a.finish_slip_days > 0 ? `+${a.finish_slip_days}` : a.finish_slip_days} d vs baseline</span>}
        {onProgress && !a.actual_finish && (
          <label className="inline-flex items-center gap-1 ml-auto">% complete
            <select value={a.percent_complete} onChange={(e) => onProgress(a.id, Number(e.target.value))}
              className="min-h-[44px] rounded border border-erf-borderCream px-2 bg-white" data-testid={`pm-pct-${a.id}`}>
              {[0, 10, 25, 50, 75, 90, 100].map((p) => <option key={p} value={p}>{p}</option>)}
            </select>
          </label>
        )}
      </div>
    </li>
  );
}
